/*
 * File: rendering.js
 * Project: our-wave-stories-app
 *
 * Created by Brendan Michaelsen on July 21, 2025 at 1:02 PM
 * Copyright © 2025 Our Wave, Inc. All rights reserved.
 *
 * Last Modified: July 21, 2025 at 1:18 PM
 * Modified By: Brendan Michaelsen
 */

/**
 * Utilities
 */

export const isOverflowing = (element) => {
	if (typeof element === 'undefined' || element === null) return false;

	return element.clientWidth < element.scrollWidth
		|| element.clientHeight < element.scrollHeight;
};
